import { render, staticRenderFns } from "./PerformanceTrend.vue?vue&type=template&id=623a8f46&scoped=true"
import script from "./PerformanceTrend.vue?vue&type=script&lang=js"
export * from "./PerformanceTrend.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTrend.vue?vue&type=style&index=0&id=623a8f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a8f46",
  null
  
)

export default component.exports